<!-- 评价管理-->
<template>
  <div>
  <van-tabs @click="check_eval">
    <van-tab title="待评论" name="staylist"></van-tab>
    <van-tab title="已评价" name="commlist"></van-tab>
  </van-tabs>
    <div  class="body" :is="list"></div>
  </div>
</template>
<style lang="scss" scoped>
 .body {
  height: calc(100vh - 60px);
  overflow-x: hidden;
  overflow-y: auto;
  background: #f6f6f6;
}
</style>
<script>
import staylist from './stay_list'
import commlist from './commlist'
export default {
  name: 'evaluation_admin',
  components: {staylist, commlist},
  data () {
    return {
      list: 'staylist'
    }
  },
  mounted () {
    this.$root.loadingAll = false
  },
  methods: {
    check_eval (val) {
      this.list = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/stay/evaluation_admin.vue